import { render, staticRenderFns } from "./PreviewXlCard.vue?vue&type=template&id=000273be&"
import script from "./PreviewXlCard.vue?vue&type=script&lang=ts&"
export * from "./PreviewXlCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports